import React from "react";

/**
 *
 * @returns - returns jsx
 */
const NoDataIndication = () => (
    <div className="text-muted mt-3 no-data" id="no-data">
        <p className="text-danger mb-1">
            <i className="fa fa-ban" style={{ fontSize: "40px" }}></i>
        </p>
        <h5>No Data Found!</h5>
    </div>
);

export default NoDataIndication;
